import { commons, concessionLetterRequired } from '../constants';
import { initialValuesGenerator } from '../initialValueGenerator';
import { dynamicRule } from '../rules';

export const ResgateTaesaDocs = () => {
  const rules = {
    anexoRG: dynamicRule('required'),
    anexoCPF: dynamicRule('required'),
    anexoCarta: dynamicRule('aposentado'),
  };

  const docs = {
    commons: [...commons],
    Aposentado: [...concessionLetterRequired],
  };

  const initialValues = initialValuesGenerator(docs);

  return {
    initialValues,
    rules,
    docs,
  };
};
